import BaseModel from '../base/BaseModel.model';
export default class PeerReviewer extends BaseModel {
    public evaluatedStudent?: string = "";
    public institution?: string = "";
    public date?: Date | any;
    constructor(){
        super();
        this.init();
    }

    init(){ 
        this.evaluatedStudent = "";
        this.institution = "";  
        this.date =  null;
    }
}